const $inject = ['$document'];
const clickOutside = function ($document) {
  return {
    restrict: 'A',
    scope: {
      clickOutside: '&'
    },
    link: function (scope, el) {
      $document.on('mousedown', eventHandler);

      scope.$on('$destroy', function() {
        $document.off('mousedown', eventHandler);
      });

      function eventHandler(e) {
        if (el !== e.target && !el[0].contains(e.target)) {
          scope.$apply(function () {
            scope.$eval(scope.clickOutside);
          });
        }
      }
    }
  };
};

clickOutside.$inject = $inject;

export default clickOutside;


// WEBPACK FOOTER //
// ./src/components/lbaClickOutside.js